import styled from "styled-components";
import { NavLink as Link } from 'react-router-dom';

const StyledLink = styled(Link)`
 display: flex;
 align-items: center;
 padding: 1rem 3rem;
 z-index: 10;
 position: relative;
 

 .label {
    margin-left: 1rem;
    font-size: 1.6rem;
    color: rgba(33, 63, 125, 0.4);
    white-space: nowrap;
    opacity: ${(p) => Number(!p.compact)};
    transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1);
 }

    .icon-container {
        opacity: 1;
    }

 &:hover {
    .label {
        color: ${({ theme }) => theme.colors?.blue02};
    }

    .icon-container {
        color: ${({ theme }) => theme.colors?.blue02};
    }
 }

 &.active{
    background-color: rgba(57, 205, 204, 0.06);
    box-shadow: inset 3px 0px 0px #39CDCC;
    
    .label, .icon-container {
        color: ${({ theme }) => theme.colors?.blue02};
    }
  }

    @media(max-width: 920px) {
        .label {
            opacity: 1;
        }
    }
`;
const StyledSpanLink = styled.span`
 display: flex;
 align-items: center;
 padding: 1rem 3rem;
 z-index: 10;
 position: relative;
 

 .label {
    margin-left: 1rem;
    font-size: 1.6rem;
    color: rgba(33, 63, 125, 0.4);
    white-space: nowrap;
    opacity: ${(p) => Number(!p.compact)};
    transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1);
 }

    .icon-container {
        opacity: 1;
    }

 &:hover {
    .label {
        color: ${({ theme }) => theme.colors?.blue02};
    }

    .icon-container {
        color: ${({ theme }) => theme.colors?.blue02};
    }
 }

 &.active{
    background-color: rgba(57, 205, 204, 0.06);
    box-shadow: inset 3px 0px 0px #39CDCC;
    
    .label, .icon-container {
        color: ${({ theme }) => theme.colors?.blue02};
    }
  }

    @media(max-width: 920px) {
        .label {
            opacity: 1;
        }
    }
`;

const LinkContainer = styled.div`
    position: relative;
    cursor: pointer;

    &::before {
        content: "";
        position: absolute;
        height: 100%;
        width: 3px;
        background-color: rgba(57, 205, 204, 0.06);
        transform: scaleY(0);
        transition: transform .1s,
                    width .2s cubic-bezier(1,0,0,1) .1s
        ;
        box-shadow: inset 3px 0px 0px #39CDCC;
    }

    &:hover::before {
        transform: scaleY(1);
        width: 100%;
    }
`;

const IconContainer = styled.div`
    width: 16px;
    height: 16px; 
    color:rgba(33, 63, 125, 0.4);
    opacity: 1;
    svg {
        height: 16px;
        width: 16px;
    }
`;
const NavHeader = styled.div`
    margin-top: 4.1rem;
    padding: 0 3rem 1rem 3rem;
    font-weight: 500;
    font-size: 1.2rem;
    color: #545F7D;
    text-transform: uppercase;
`;



const NavLink = ({ children, icon, label, header, link, toggleNav, compact, ...rest }) => {
    return (
        <>
            {header ? <NavHeader>
                <span>{header}</span>
            </NavHeader> : (
                <LinkContainer>
                    {link ? (
                        <StyledLink to={link} onClick={toggleNav} compact={compact} {...rest}>
                            {children || (
                                <>
                                    <IconContainer className="icon-container">
                                        {icon}
                                    </IconContainer>
                                    <div className="label"><span>{label}</span></div>

                                </>
                            )}
                        </StyledLink>
                    ) : (
                        <StyledSpanLink onClick={toggleNav} compact={compact} {...rest}>
                            {children || (
                                <>
                                    <IconContainer className="icon-container">
                                        {icon}
                                    </IconContainer>
                                    <div className="label"><span>{label}</span></div>
                                </>
                            )}
                        </StyledSpanLink>
                    )}
                </LinkContainer>
            )}
        </>
    )
}

export default NavLink
